import React from "react";
import styled, { withTheme } from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";

const SkipButton = styled.button`
  height: 1px;
  margin: 0;
  opacity: 0;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 1px;
  outline: none;
  border: none;
  &:focus {
    opacity: 1;
    overflow: visible;
    background: ${props => props.theme.color.white};
    box-shadow: none;
    border: none;
    outline: none;
    &:-moz-focusring {
      overflow: visible;
      outline: none;
    }
  }
  span {
    background: ${props => props.theme.color.white};
    color: ${props => props.theme.vstui.color.primary.getShade(6)};
    font-size: 1.3rem;
    outline: 1px dotted ${cloud.getShade(5)};
    padding: 10px 20px;
    position: absolute;
    text-decoration: underline;
    ${props => `top: ${props.top}px`}
    ${props => `left: ${props.left}px`}
    width: max-content;
    display: inline-table;
    white-space: nowrap;
  }
`;

const AccessibleSkipButton = ({
  props,
  focusRef,
  skipClick,
  label,
  top,
  left
}) => (
  <SkipButton
    {...props}
    top={top}
    left={left}
    innerRef={focusRef}
    onClick={skipClick}
  >
    <span>{label}</span>
  </SkipButton>
);

export default withTheme(AccessibleSkipButton);
